import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FAQ from "@/components/FAQ";
import ContactForm from "@/components/ContactForm";
import CTABanner from "@/components/CTABanner";
import PageHero from "@/components/PageHero";
import { FileCheck } from "lucide-react";

export default function FAQFullPage() {
  const { t } = useTranslation();
  return (
    <div data-testid="page-faq-full" className="relative overflow-x-hidden">
      <Navbar />
      <PageHero
        breadcrumb={[{ label: t("common.resources", "Resources") }, { label: "FAQ" }]}
        pill={{ Icon: FileCheck, text: "FAQ" }}
        title={t("faqPage.titlePart1", "Everything about")}
        accent={t("faqPage.titleAccent", "OFinancial Markets")}
        subline={t("faqPage.subline", "Answers covering account opening, MT5 platforms, spreads, swaps, funding methods, withdrawals and compliance. Browse by category or search below.")}
        primary={{ label: t("common.contactUs", "Contact us"),  to: "/contact" }}
        secondary={{ label: t("common.browseGlossary", "Browse glossary"), to: "/glossary" }}
      />
      <main className="pb-20">
        <FAQ />
        <ContactForm />
      </main>
      <CTABanner />
      <Footer />
    </div>
  );
}
